import { useContext, useState, useEffect } from 'react';
import { Button, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import api from '../../../../api/api.js';
import { isDemo, AppContext, WidgetsContext } from '../../../GlobalContex';
import useNotifications from '../../../hooks/useNotifications';
import { useAnalytics } from '../../../hooks/useAnalytics';

const TwitterAccountConnectInput = () => {
  const { t } = useTranslation();
  const notification = useNotifications();
  const [account, setAccount] = useState('');
  const { activeWidget, setActiveWidgetSettings, activeWidgetMeta } = useContext(WidgetsContext);
  const { sendEvent } = useAnalytics();

  useEffect(() => {
    setAccount(activeWidget?.settings?.account || '');
  }, [activeWidget?.id]);

  async function connectTwitterAccount(account) {
    try {
      const payload = await api.connectTwitterAccount(
        activeWidgetMeta.connectAccountUrl || `apps/twitter-feed/widgets/${activeWidget.id}/data`,
        account,
        { preview: isDemo }
      );
      sendEvent('connect_account', {
        account: 'twitter'
      });
      setActiveWidgetSettings(payload);
    } catch (err) {
      if (err.code === 'E_INVALID_ACCOUNT') {
        err = new Error(t('Invalid username: "{{account}}"', { account }));
      }
      notification.error(err.message);
    }
  }

  function clickHandle() {
    connectTwitterAccount(account);
  }

  function changeHandle(e) {
    const { value } = e.target;
    setAccount(value);
  }

  return (
    <>
      <Form.Group className={'mb-3'}>
        <Form.Label className="mb-3">{t('Twitter username:')}</Form.Label>
        <Form.Control
          className="mb-3"
          value={account}
          onChange={changeHandle}
          placeholder="elonmusk"
        />
      </Form.Group>
      <Form.Group>
        <Button className="w-100" variant="primary" onClick={clickHandle}>
          {t('Connect')}
        </Button>
      </Form.Group>
    </>
  );
};

export default TwitterAccountConnectInput;